{
  raise: (message, data = null) -> perform(
    @dvala.error,
    { type: "UserError", message: message, data: data }
  ),
};
